var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
// styles
import "./missingPage.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    dataTestId: "tecma-missingPage",
};
const MissingPage = (_a) => {
    var { className, dataTestId } = _a, rest = __rest(_a, ["className", "dataTestId"]);
    const classList = classNames("tecma-missingPage", className);
    return (_jsx("div", Object.assign({ className: classList, "data-testid": dataTestId }, rest, { children: "The page you are looking for does not exist. Please check the url." })));
};
MissingPage.defaultProps = defaultProps;
export default React.memo(MissingPage);
